import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './BigInfoBox.module.scss';

export default class BigInfoBoxComponent extends Component {
  static defaultProps = {
    className: ''
  };

  static propTypes = {
    item: PropTypes.object.isRequired
  };

  render() {
    const {
      className,
      item: { header, slogan, description, logo }
    } = this.props;

    return (
      <div className={`${styles.BigInfoBox} ${className}`}>
        <div className={styles.BigInfoBoxImage}>
          <img
            src={OptimizeImagesService.adjustImageSize(logo)}
            alt="Big logo"
            className={styles.BigInfoBoxLogo}
          />
        </div>
        <div className={styles.BigInfoBoxImage}>
          <h3 className={styles.BigInfoBoxImgDescription}>{header}</h3>
        </div>
        <div className={styles.BigInfoBoxColumn}>
          <h2 className={styles.BigInfoBoxHeading}>{slogan}</h2>
        </div>
        <div className={`${styles.BigInfoBoxColumn}`}>
          <p className={styles.BigInfoBoxDescription}>{description}</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/MissionAndVision/components/BigInfoBox/BigInfoBox.js